/**
 * Banners Example Section
 */

// Banner with supporting icon
const BANNER_WITH_SUPPORTING_ICON_HTML = `
  // Banner content to be loaded
  <div atlas-banner>
    <div atlas-banner-image>
      <mat-icon>
        videocam
      </mat-icon>
    </div>
    <div atlas-banner-content>
      <p class="m-0 mat-body">
        The video camera function is currently being turned off.
      </p>
    </div>
    <div atlas-banner-actions>
      <button atlas-button
        color="accent"
        class="text-uppercase me-2"
        (click)="getDismissAction()">
        Dismiss
      </button>
      <button atlas-button
        color="accent"
        class="text-uppercase"
        (click)="performAction()">
        Go To Buttons
      </button>
    </div>
  </div>`;

const BANNER_WITH_SUPPORTING_ICON_TYPESCRIPT = `
  @Component({
    selector: 'app-banner-demo-t1',
    templateUrl: './banner-demo-t1.component.html',
  })
  export class BannerDemoT1Component {
    imageUrl: string;

    constructor(private route: Router, private bannerRef: AtlasBannerRef<BannerDemoT1Component>) {
      this.imageUrl = '../../../assets/images/banner_icon.png';
    }

    /**
     * Perform Dismiss Action for Banner
     */
    getDismissAction() {
      // Trigger close for banner
      this.bannerRef.close();
    }

    /**
     * Perform Action on Banner
     */
    performAction() {
      // Trigger close for banner
      this.bannerRef.close();

      // Perform action on banner
      this.route.navigateByUrl('button');
    }
  }`;

const BANNER_WITH_SUPPORTING_ICON_DEMO_HTML = `
  // Banner Demo component which opens Banner content component
  <button atlas-outlined-button
    class="me-3"
    color="accent"
    (click)="openTemplate1()">
    Banner Template 1
  </button>`;

const BANNER_WITH_SUPPORTING_ICON_DEMO_TS = `
  // Banner Demo component which opens Banner content component
  @Component({
    selector: 'dls-example',
    templateUrl: './example.component.html',
    styleUrls: ['./example.component.scss']
  })
  export class ExampleComponent {
    public atlasBannerRef: AtlasBannerRef<ExampleComponent>;

    constructor(private bannerService: AtlasBannerService) {}

    /**
     * Open Banner Template 1 with suppporting icon
     */
    openTemplate1(): void {
      // To check whether banner is already opened or not. If false then open Banner.
      if (!this.bannerService.isBannerLoaded) {
        this.atlasBannerRef = this.bannerService.open(BannerDemoT1Component);
      }

      /**
       * Subscription for afterClosed
       */
      this.atlasBannerRef.afterClosed.subscribe((_) => {
        // user can perform action after banner is closed
      });
    }
  }
`;

// Banner without supporting icon
const BANNER_WITHOUT_SUPPORTING_ICON_HTML = `
  // Banner content to be loaded
  <div atlas-banner>
    <div atlas-banner-content>
      <p class="m-0 mat-body">
        The notification function is currently being turned off.
      </p>
    </div>
    <div atlas-banner-actions>
      <button atlas-button
        color="accent"
        class="text-uppercase me-2"
        (click)="getDismissAction()">
        Dismiss
      </button>
      <button atlas-button
        color="accent"
        class="text-uppercase">
        Turn on notification
      </button>
    </div>
  </div>`;

const BANNER_WITHOUT_SUPPORTING_ICON_TYPESCRIPT = `
  @Component({
    selector: 'app-banner-demo-t2',
    templateUrl: './banner-demo-t2.component.html',
  })
  export class BannerDemoT2Component {

    constructor(private bannerRef: AtlasBannerRef<BannerDemoT1Component>) {}

    /**
     * Perform Dismiss Action for Banner
     */
    getDismissAction() {
      // Trigger close for banner
      this.bannerRef.close();
    }
  }
`;

const BANNER_WITHOUT_SUPPORTING_ICON_DEMO_HTML = `
  // Banner Demo component which opens Banner content component
  <button atlas-outlined-button
    class="me-3"
    color="accent"
    (click)="openTemplate2()">
    Banner Template 2
  </button>
  `;

const BANNER_WITHOUT_SUPPORTING_ICON_DEMO_TS = `
  // Banner Demo component which opens Banner content component
  @Component({
    selector: 'dls-example',
    templateUrl: './example.component.html',
    styleUrls: ['./example.component.scss']
  })
  export class ExampleComponent {
    public atlasBannerRef: AtlasBannerRef<ExampleComponent>;

    constructor(private bannerService: AtlasBannerService) {}

    /**
     * Open Banner Template 2 without supporting icon
     */
    openTemplate2(): void {
      // To check whether banner is already opened or not. If false then open Banner.
      if (!this.bannerService.isBannerLoaded) {
        this.atlasBannerRef = this.bannerService.open(BannerDemoT2Component);
      }

      /**
       * Subscription for afterClosed
       */
      this.atlasBannerRef.afterClosed.subscribe((_) => {
        // user can perform action after banner is closed
      });
    }
  }
`;

  // Dynamic Data
const BANNER_DYNAMIC_DATA_HTML = `
  // Banner content to be loaded
  <div atlas-banner>
    <img atlas-banner-image
      [src]="data.imageURL">
    <div atlas-banner-content>
      <p class="m-0 mat-body">
        {{data.content}}
      </p>
    </div>
    <div atlas-banner-actions>
      <button atlas-button
        color="accent"
        class="text-uppercase me-2"
        (click)="getDismissAction()">
        {{data.secondaryAction}}
      </button>
      <button atlas-button
        color="accent"
        class="text-uppercase"
        (click)="performAction()">
        {{data.primaryAction}}
      </button>
    </div>
  </div>`;

const BANNER_DYNAMIC_DATA_TYPESCRIPT = `
  // interface for data
  export interface BannerData {
    content: string;
    imageURL: string;
    primaryAction: string;
    secondaryAction: string;
  }

  @Component({
    selector: 'app-banner-demo-t3',
    templateUrl: './banner-demo-t3.component.html',
  })
  export class BannerDemoT3Component {

    constructor(private route: Router, private bannerRef: AtlasBannerRef<BannerDemoT3Component>,
      @Inject(ATLAS_BANNER_DATA) public data: BannerData) {
    }

    /**
     * Perform Dismiss Action for Banner
     */
    getDismissAction() {
      // Trigger close for banner
      this.bannerRef.close();
    }

    /**
     * Perform Action on Banner
     */
    performAction() {
      // Trigger close for banner
      this.bannerRef.close();

      // Perform action on banner
      this.route.navigateByUrl('button');
    }
  }`;

const BANNER_DYNAMIC_DATA_DEMO_HTML = `
  // Banner Demo component which opens Banner content component
  <div class="row mb-4">
    <div class="col-12 col-md-6">
      <h3 class="mat-headline">
        Passing Dynamic Data
      </h3>
      <form
        [formGroup]="bannerForm"
        (ngSubmit)="openTemplate3()">
        <atlas-input
          formControlName="content"
          type="text"
          required>
          <span label>
            Content
          </span>
        </atlas-input>
        <atlas-input
          formControlName="imageURL"
          type="text"
          required>
          <span label>
            Image URL
          </span>
        </atlas-input>
        <atlas-input
          formControlName="secondaryAction"
          type="text"
          required>
          <span label>
            Secondary Action
          </span>
        </atlas-input>
        <atlas-input
          formControlName="primaryAction"
          type="text"
          required>
          <span label>
            Primary Action
          </span>
        </atlas-input>
        <button atlas-contained-button
          color="accent"
          class="text-uppercase w-100 mt-3"
          [disabled]="bannerForm.invalid">
          Add Dynamic Data
        </button>
      </form>
    </div>
  </div>`;

const BANNER_DYNAMIC_DATA_DEMO_TS = `
  // Banner Demo component which opens Banner content component
  @Component({
    selector: 'dls-example',
    templateUrl: './example.component.html',
    styleUrls: ['./example.component.scss']
  })
  export class ExampleComponent {
  public atlasBannerRef: AtlasBannerRef<ExampleComponent>;
  bannerForm: FormGroup;

  constructor(private bannerService: AtlasBannerService) {
    this.bannerForm = new FormGroup({
      content: new FormControl('', Validators.required),
      imageURL: new FormControl('', Validators.required),
      primaryAction: new FormControl('', Validators.required),
      secondaryAction: new FormControl('', Validators.required)
    });
  }

  // Open Dynamic Data Template
  openTemplate3(): void {
    // To check whether banner is already opened or not. If false then open Banner.
    if (!this.bannerService.isBannerLoaded) {
      this.atlasBannerRef = this.bannerService.open(BannerDemoT3Component,
        {
          data: {
            content: this.bannerForm.controls['content'].value,
            imageURL: this.bannerForm.controls['imageURL'].value,
            primaryAction: this.bannerForm.controls['primaryAction'].value,
            secondaryAction: this.bannerForm.controls['secondaryAction'].value
          }
        });
      }
    }`;

  // Show and close programmatically
const BANNER_SHOW_CLOSE_PROGRAMMATICALLY_HTML = `
  // Banner content to be loaded
  <div atlas-banner>
    <div atlas-banner-content>
      <p class="m-0 mat-body">
        Your Password was updated in your other device. Please sign in again.
      </p>
    </div>
  </div>`;

const BANNER_SHOW_CLOSE_PROGRAMMATICALLY_TS = `
  @Component({
    selector: 'app-banner-demo-t4',
    templateUrl: './banner-demo-t4.component.html',
  })
  export class BannerDemoT4Component {
    constructor() {}
  }
`;

const BANNER_SHOW_CLOSE_PROGRAMMATICALLY_DEMO_HTML = `
  // Banner Demo component which opens Banner content component
  <button atlas-outlined-button
    class="me-3"
    color="accent"
    (click)="openTemplate4()">
    Show Banner
  </button>
  <button atlas-outlined-button
    color="accent"
    (click)="onBannerClose()">
    Close Banner
  </button>`;

const BANNER_SHOW_CLOSE_PROGRAMMATICALLY_DEMO_TS = `
  // Banner Demo component which opens Banner content component
  @Component({
    selector: 'dls-example',
    templateUrl: './example.component.html',
    styleUrls: ['./example.component.scss']
  })
  export class ExampleComponent {
    public atlasBannerRef: AtlasBannerRef<ExampleComponent>;

    constructor(private bannerService: AtlasBannerService) {}

    openTemplate4(): void {
      // To check whether banner is already opened or not. If false then open Banner.
      if (!this.bannerService.isBannerLoaded) {
        this.atlasBannerRef = this.bannerService.open(BannerDemoT4Component);
      }
      /**
       * Subscription for afterClosed
       */
      this.atlasBannerRef.afterClosed.subscribe((_) => {
        // user can perform action after banner is closed
      });
    }

    onBannerClose(): void {
      this.atlasBannerRef.close();
    }`;

// CSS changes
const NO_SCSS_CHANGES = `/** No SCSS changes */`;

 /**
 * Exports
 */
export const EXAMPLE = {
  'BANNER_WITH_SUPPORTING_ICON': {
    'HTML': BANNER_WITH_SUPPORTING_ICON_HTML,
    'DEMOHTML': BANNER_WITH_SUPPORTING_ICON_DEMO_HTML,
    'TS': BANNER_WITH_SUPPORTING_ICON_TYPESCRIPT,
    'DEMOTS': BANNER_WITH_SUPPORTING_ICON_DEMO_TS,
    'SCSS': NO_SCSS_CHANGES
  },
  'BANNER_WITHOUT_SUPPORTING_ICON': {
    'HTML': BANNER_WITHOUT_SUPPORTING_ICON_HTML,
    'DEMOHTML': BANNER_WITHOUT_SUPPORTING_ICON_DEMO_HTML,
    'TS': BANNER_WITHOUT_SUPPORTING_ICON_TYPESCRIPT,
    'DEMOTS': BANNER_WITHOUT_SUPPORTING_ICON_DEMO_TS,
    'SCSS': NO_SCSS_CHANGES
  },
  'DYNAMIC_DATA': {
    'HTML': BANNER_DYNAMIC_DATA_HTML,
    'DEMOHTML': BANNER_DYNAMIC_DATA_DEMO_HTML,
    'TS': BANNER_DYNAMIC_DATA_TYPESCRIPT,
    'DEMOTS': BANNER_DYNAMIC_DATA_DEMO_TS,
    'SCSS': NO_SCSS_CHANGES
  },
  'SHOW_CLOSE_PROGRAMMATICALLY': {
    'HTML': BANNER_SHOW_CLOSE_PROGRAMMATICALLY_HTML,
    'DEMOHTML': BANNER_SHOW_CLOSE_PROGRAMMATICALLY_DEMO_HTML,
    'TS': BANNER_SHOW_CLOSE_PROGRAMMATICALLY_TS,
    'DEMOTS': BANNER_SHOW_CLOSE_PROGRAMMATICALLY_DEMO_TS,
    'SCSS': NO_SCSS_CHANGES
  }
};
